import React, { useState, useEffect } from 'react';
import paginationFactory from 'react-bootstrap-table2-paginator';
import cellEditFactory from 'react-bootstrap-table2-editor';
import Table from '../../../../../../pages/private/components/table/Table';
import Config from './TableConfig';
import { NotButtons, TableBoxAnimation } from '../../../../../../pages/private/components/table/Table.style';

function ButtonsTable({
  screen, handleTableIcon, afterSaveCell, screenList, queue, fieldsList, dictOptions,
}) {
  const { buttons } = screen;
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 1350);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const Setting = Config({
    screen, screenList, queue, dictOptions, fieldsList, isMobile,
  });
  const { columns } = Setting;

  return (
    <TableBoxAnimation show={Boolean(buttons)}>
      {buttons ? (
        <div style={{ overflowX: 'auto' }}>
          <Table
            keys="id"
            data={buttons}
            columns={columns}
            cellEdit={cellEditFactory({
              mode: 'click',
              blurToSave: true,
              afterSaveCell,
            })}
            handleIcon={handleTableIcon}
            pagination={paginationFactory()}
          />
        </div>
      )
        : <NotButtons>Кнопок нет</NotButtons>}
    </TableBoxAnimation>
  );
}

export default ButtonsTable;
